export const getMissingErrorMsg = (args: { [key: string]: unknown }, message: string) => {
  const missingVars: string = Object.keys(args)
    .filter((k) => !args[k])
    .join("', '");
  return `${message}. Could not find '${missingVars}'`;
};
